import * as React from "react";

import { LinkList } from "../LinkList/LinkList";
import styled from "styled-components";
import { NAV } from "../../../consts/style";
import { IMenuItem } from "../IMenuItem";

const LinkListContainer = styled.div`
  display: flex;
  flex-basis: 33%;
`;

const DropdownContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 142px;
  margin-left: auto;
  margin-right: auto;
  max-width: ${NAV.DROPDOWN_MENU.DROPDOWN.WIDTH};
  width: 100%;
  background-color: white;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);
  z-index: ${NAV.DROPDOWN_MENU.Z_INDEX};
`;

const DropdownInnerContainer = styled.div`
  padding: 26px 76px;
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
`;

interface Props {
  menuItems: IMenuItem[];
  children: React.ReactNode;
}

export const Dropdown = ({ menuItems, children }: Props) => (
  <DropdownContainer>
    <DropdownInnerContainer>
      {menuItems.map((item, ix) => (
        <LinkListContainer key={`${ix}-${item.title}`}>
          <LinkList menuItems={item.children} titleMenuItem={item} />
        </LinkListContainer>
      ))}
      {children}
    </DropdownInnerContainer>
  </DropdownContainer>
);
